module.exports = __webpack_public_path__ + "static/media/mi.731fa188.jpg";